import * as Yup from 'yup';
import { compact } from 'lodash';
import { Option } from 'src/components/SelectOption';
import AutoCompleteBox from 'src/components/AutoCompleteBox';
import Select from 'src/components/Select';
import AutoCompleteWithFreeText from 'src/components/AutoComplete/AutoCompleteWithFreeText';
import { SolutionSourcePullImageItemField } from '../../types/solutionEdgeWorkload';

export const SourcePullImageFormFields = (
  repoNameOptions?: Option[],
  options?: Option[],
  canSelectImage?: string | boolean,
  handleChange?: any
) =>
  compact([
    {
      name: SolutionSourcePullImageItemField.SourceRepoName,
      label: 'Repository Name',
      Component: Select,
      options: repoNameOptions,
      onChange: handleChange,
      placeholder: 'Enter the name',
      required: true,
      validation: Yup.string().required('Repository Name is required'),
    },
    canSelectImage === true && {
      name: SolutionSourcePullImageItemField.Images,
      label: 'Images',
      Component: AutoCompleteBox,
      validation: Yup.array()
        .nullable()
        .min(1)
        .required('Image selection is required'),
      options,
      sx: { height: '40rem' },
      initialValue: [],
      placeholder: 'Search images or tag',
      required: true,
      multiple: true,
    },
    canSelectImage === false && {
      name: SolutionSourcePullImageItemField.Images,
      label: 'Images',
      placeholder: 'Type Image name : tag',
      Component: AutoCompleteWithFreeText,
      options: [],
      validation: Yup.array()
        .min(1)
        .required('Atleast one table name is required')
        .nullable(),
      autocompleteRows: 4,
      multiple: true,
    },
  ]);
